// test1993
(1993 && 0);
